"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentReferences = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const isAbsoluteUrl = (href) => /^https?:\/\//.test(href);
let ComponentReferences = class ComponentReferences extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = 'References';
        this.items = [];
    }
    get groups() {
        if (this.items.length === 0)
            return [];
        if (Array.isArray(this.items[0]))
            return this.items;
        return [this.items];
    }
    render() {
        return (0, lit_1.html) `
      <div class="references-body">
        <mm-heading>${this.heading}</mm-heading>
        <mm-surface variant="filled" radius="large" style="padding-inline: 1.25rem">
          ${this.groups.map((group, index) => this.renderGroup(group, index))}
        </mm-surface>
      </div>
    `;
    }
    renderGroup(group, index) {
        return (0, lit_1.html) `
      ${index > 0
            ? (0, lit_1.html) `
            <mm-separator></mm-separator>
          `
            : null}
      <div class="references-links">${group.map(item => this.renderLink(item))}</div>
    `;
    }
    renderLink({ href, label, external }) {
        const isExternal = external ?? isAbsoluteUrl(href);
        return (0, lit_1.html) `
      <mm-link ?external=${isExternal} href=${href}>${label}</mm-link>
    `;
    }
};
ComponentReferences.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    .references-body {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }

    .references-links {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-1) var(--space-4);
    }

    .component-references {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
      padding: var(--space-section) 0;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentReferences.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ComponentReferences.prototype, "items", void 0);
ComponentReferences = __decorate([
    (0, decorators_js_1.customElement)('mm-component-references')
], ComponentReferences);
exports.ComponentReferences = ComponentReferences;
//# sourceMappingURL=data:application/json;base64,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